import React from "react";
const Instagram = (props) => {
  return (
    <svg
      {...props}
      version="1.1"
      id="Icons"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 32 32"
    >
      <path d="M23,0H9C4,0,0,4,0,9v6v8c0,5,4,9,9,9h14c5,0,9-4,9-9v-8V9C32,4,28,0,23,0z" />
      <circle fill="#fff" cx="16" cy="16" r="8" />
      <circle fill="#000" cx="16" cy="16" r="4" />
      <circle fill="#fff" cx="25" cy="6" r="2" />
    </svg>
  );
};

export default Instagram;
